import { render } from "./VoucherView.vue?vue&type=template&id=0911d792"
import script from "./VoucherView.vue?vue&type=script&lang=ts"
export * from "./VoucherView.vue?vue&type=script&lang=ts"
script.render = render

export default script